import React from "react";
import { AkilDataList } from "./AkilListRow";

/** Basit markdown: satır sonları + **kalın** */
export function AiMarkdown({ text, className = "" }) {
    if (!text) return null;
    const lines = String(text).split("\n");
    return (
        <div className={`space-y-2 text-sm leading-relaxed text-slate-200 ${className}`}>
            {lines.map((line, i) => {
                if (!line.trim()) return <div key={i} className="h-1" />;
                const parts = line.split(/(\*\*[^*]+\*\*)/g);
                return (
                    <p key={i} className={line.startsWith("•") ? "pl-1" : ""}>
                        {parts.map((part, j) => {
                            if (part.startsWith("**") && part.endsWith("**")) {
                                return (
                                    <strong key={j} className="text-[#F3E5AB] font-semibold">
                                        {part.slice(2, -2)}
                                    </strong>
                                );
                            }
                            return <span key={j}>{part}</span>;
                        })}
                    </p>
                );
            })}
        </div>
    );
}

/** @deprecated AkilDataList kullanın */
export function renderAkilListe(items) {
    return <AkilDataList items={items} />;
}
